import { useRouter } from 'next/navigation'
import { useEffect } from 'react'

import ROUTES from 'config/routes.json'
import { useAppSelector } from 'store/hooks'
import { getLocationDataSelector } from 'store/modules/appConfig/selectors'
import { jumioKycAddressSelector } from 'store/modules/kyc/selectors'
import { getUserFirstPurchaseSelector, getUserSelector, softKycAddressLineSelector } from 'store/modules/user/selectors'

export default function useSecureAccountRedirect() {
  const router = useRouter()
  const user = useAppSelector(getUserSelector)
  const location = useAppSelector(getLocationDataSelector)
  const jumioKycAddress = useAppSelector(jumioKycAddressSelector)
  const softKycAddress = useAppSelector(softKycAddressLineSelector)
  const firstPurchase = useAppSelector(getUserFirstPurchaseSelector)
  const locationConditions = location?.country === 'US' && location?.state === 'NV'

  const isSecureAccountRedirect = locationConditions && !jumioKycAddress && !softKycAddress && !firstPurchase

  useEffect(() => {
    if (user && isSecureAccountRedirect) {
      router.push(ROUTES.SECURE_YOUR_ACCOUNT)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user, isSecureAccountRedirect])
}
